import React from "react";
import logoImg from "./img/logo.svg";
import "./Logo.css";

const Logo = () => (
  <div className="Logo">
    <img src={logoImg} alt="Type Draw Type Game" />
  </div>
);

export default Logo;
